export const shouldRender = (data) => {
    return data.currentAccount.isUnlimited;
};
export const Component = function UnlimitedAccount() {
    return null;
};
//# sourceMappingURL=UnlimitedAccount.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
